"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Paragraph extends React.Component {
    render() {
        const { content } = this.props;
        return (React.createElement("p", { className: "text-no-results", dangerouslySetInnerHTML: { __html: content } }));
    }
}
exports.Paragraph = Paragraph;
exports.default = Paragraph;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-paragraph/Paragraph.tsx